import axios from 'axios';
import { useContext } from 'react';
import { charsheetAPI, TABLE_USERS } from '../globals.js';


const createUser = async ( userName, userAlias='', campaigns={} ) => {

    const userTable = TABLE_USERS
    // const campaignName = 'js-test-campaign'
    const queryAPI = charsheetAPI + '?TableName=' + userTable + '&UserName=' + userName;

    // Get current UTC time and format as YYYY-MM-DDTHH:MM:SSZ
    const now = new Date();
    const createdAt = now.toISOString().split('.')[0] + 'Z';
    
    const payload = {
        createdAt: createdAt,
        username_alias: userAlias,
        createdBy: userName,
        characterCount: 0,
        campaigns: campaigns,
    };

    try {
        const response = await axios({
            host: charsheetAPI,
            method: 'PUT',
            url: queryAPI,
            headers: { 'content-type': 'text/plain' }, 
            data: { ...payload },   // this is the 'body' in AWS
        });

        console.log('Successfully saved to DynamoDB:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error saving to DynamoDB:', error.response ? error.response.data : error.message);
        throw error;
    }
}        

export default createUser;